import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#3D2B1F] text-[#C4B89C] py-8 px-4 border-t border-[#5C4033]" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center" data-id="element-110">
        <p className="mb-4" data-id="element-111">
          © 2026 Crianza Montessori en Casa. Todos los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4 text-sm" data-id="element-112">
          <a href="#" className="hover:text-white transition-colors" data-id="element-113">
            Privacidad
          </a>
          <span data-id="element-114">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-115">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}